import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {ChatListNew} from '@components/right-panel/chat-list/chat-list-new'
import {SearchHintNothingFound} from './search-hint'
import {TwSearchDivider} from './search-popup'
import {SearchResultView} from './search-results'
import {itemHeight, useSearchStore} from './search-store'

export interface SearchNotFoundProps {
  hideTitle?: boolean
}

export const SearchNotFound = observer(() => {
  const [state, store] = useSearchStore()

  const resEveryWhere = store.resultsEveryWhere

  if (resEveryWhere.length === 0) {
    return <SearchHintNothingFound />
  }

  return (
    <div className="flex-1 flex min-h-0 flex-col relative isolate">
      <div className="p-8 text-sm-semibold text-primary mb-16 cursor-default">
        {Lang.msg.searchResults2}
      </div>

      <TwSearchDivider />

      <div className="p-8 text-sm-regular text-secondary mb-8 cursor-default">
        {Lang.msg.searchResults3}
      </div>

      <WithPerfectScrollbar
        containerRef={store.setScrollableEl}
        onScroll={store.onListScroll}
        onMouseMove={store.showCursor}
        className="flex-1 pr-8 -mr-8"
        wheelPropagation
        wheelSpeed={1.5}
      >
        <ChatListNew
          ref={store.setContainerEl}
          chatView={SearchResultView}
          chats={resEveryWhere}
          selectedIx={state.selectedIx}
          from={state.listFrom}
          to={state.listTo}
          itemClick={store.itemClick}
          itemHover={store.itemHover}
          itemHeight={itemHeight}
        />
      </WithPerfectScrollbar>
    </div>
  )
})
